import React from 'react';
import { TabPanel, TabContext } from '@mui/lab';
import IconCourses from '@mui/icons-material/Groups';
import Button from '@mui/material/Button';
import IconUsers from '@mui/icons-material/School';
import { ButtonStyle, IconUserStyle, IconCourseStyle } from './style';

export default function UnstyledTabsCustomized({ onclick = () => {}, value = false }) {
  return (
    <TabContext value="0">
      <TabPanel value="0" style={{ display: 'Flex', with: '100%' }}>
        <Button onClick={() => onclick(true)} style={ButtonStyle}>
          <IconCourses style={IconCourseStyle(value)} />
        </Button>
        <Button onClick={() => onclick(false)} style={ButtonStyle}>
          <IconUsers style={IconUserStyle(value)} />
        </Button>
      </TabPanel>
    </TabContext>
  );
}
